import { combineActions, handleActions } from 'redux-actions'

import { publishAiReport } from '../actions'

const defaultState = false

export default handleActions(
  {
    [publishAiReport.request]() {
      return true
    },
    [combineActions(publishAiReport.success, publishAiReport.failed, publishAiReport.cancel)]() {
      return false
    },
  },
  defaultState
)
